import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { setPageMeta } from "@/lib/seo";
import { Loader2 } from "lucide-react";
import { SITE_CONTAINER_NARROW } from "@/lib/siteLayout";

export function LegalDocumentPage({ title, description, sections, operator, loading, testId }) {
  useEffect(() => {
    if (!title) return;
    setPageMeta({
      title,
      description,
      url: typeof window !== "undefined" ? window.location.href : undefined,
    });
  }, [title, description]);

  const effectiveDate = operator?.effectiveDate;

  return (
    <div className="dark min-h-screen bg-anthracite-900 text-white">
      <Navbar />
      <main data-testid={testId} className="pt-28 pb-16">
        <div className={SITE_CONTAINER_NARROW}>
          {loading ? (
            <div className="flex justify-center py-20">
              <Loader2 className="w-8 h-8 text-electric animate-spin" />
            </div>
          ) : (
            <>
              <p className="text-[10px] uppercase tracking-[0.25em] text-slate-500 mb-2">Jogi dokumentum</p>
              <h1 className="font-heading text-3xl md:text-4xl font-medium tracking-tight">{title}</h1>
              {effectiveDate && (
                <p className="text-sm text-slate-500 mt-3">
                  Hatályos: {effectiveDate} · {operator?.brand || "AutoPark"}
                </p>
              )}

              <div className="mt-10 space-y-10">
                {(sections || []).map((sec) => {
                  const anchorId =
                    sec.id === "cookies" || /sütik/i.test(sec.title || "")
                      ? "sutik"
                      : undefined;
                  return (
                  <section key={sec.id || sec.title} id={anchorId}>
                    <h2 className="font-heading text-xl text-white mb-3">{sec.title}</h2>
                    {sec.body?.map((p, i) => (
                      <p key={i} className="text-sm text-slate-300 leading-relaxed mb-3">
                        {p}
                      </p>
                    ))}
                    {sec.list?.length > 0 && (
                      <ul className="list-none space-y-2 text-sm text-slate-300">
                        {sec.list.map((item) => (
                          <li key={item} className="flex gap-2">
                            <span className="text-electric shrink-0">•</span>
                            <span>{item}</span>
                          </li>
                        ))}
                      </ul>
                    )}
                  </section>
                  );
                })}
              </div>

              <div className="mt-12 pt-8 border-t border-white/10 flex flex-wrap gap-4 text-sm">
                <Link to="/adatvedelem" className="text-electric hover:underline">
                  Adatvédelmi tájékoztató
                </Link>
                <Link to="/aszf" className="text-electric hover:underline">
                  ÁSZF
                </Link>
                <Link to="/" className="text-slate-400 hover:text-white">
                  Főoldal
                </Link>
              </div>
            </>
          )}
        </div>
      </main>
      <Footer />
    </div>
  );
}
